module.exports = __webpack_public_path__ + "static/media/thumbnail.cf9e5150.jpg";